module.exports = __webpack_public_path__ + "img/微信图片_20251027135744_1189_62.ccf743c2.jpg";